import React from "react"

import { FaBars } from "../../AppReactIcons"
import { WhiteAppButton } from "../buttons"

const NavbarMenuButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <React.Fragment>
    <div className="hidden sm:block">
      <WhiteAppButton Icon={<FaBars />} title="Menu" onClick={onClick} />
    </div>
    <div className="block sm:hidden">
      <WhiteAppButton Icon={<FaBars />} title="Menu" onClick={onClick} />
    </div>
  </React.Fragment>
)

export default NavbarMenuButton
